export const sitesKeys = {
  all: ["site-sites"] as const,
  lists: () => [...sitesKeys.all, "list"] as const,
  list: () => [...sitesKeys.lists()] as const,
  details: () => [...sitesKeys.all, "detail"] as const,
  detail: (token: string) => [...sitesKeys.details(), token] as const,
};
